import type { Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { ImportService } from '#/app/shared/services/api/import.service';

import { resolveResourceAccessGuardResult } from './resource-access-guard';

/**
 * Guard that verifies an import file exists and belongs to the tenant in the route.
 * Prevents route matching if the import file doesn't exist or belongs to a different tenant,
 * allowing fallback routes to handle 404 display.
 */
export const importAccessCanMatchGuard: CanMatchFn = (
  _routes,
  _segments,
  _currentSnapshot,
) => {
  const importService = inject(ImportService);
  const importIdParam = _currentSnapshot?.paramMap.get('importId') ?? '';

  return resolveResourceAccessGuardResult(importIdParam, (importIdSignal) =>
    importService.importResource(importIdSignal as Signal<string>),
  );
};
